<template>
    <div class="memberAdd">
        <v-card class="cardWrap">
            <CardTitle :title="page_title" />
            <v-card-actions class="cardWrap__scroll">
                <v-form
                    class="cardWrap__fromArea"
                    ref="form"
                    v-model="valid"
                    :lazy-validation="lazy"
                    >
                    <v-container>
                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">氏名</div>
                            <v-text-field
                                class="px-3"
                                disabled
                                v-model="from_set_data.family_name"
                            />
                            <v-text-field
                                class="px-3"
                                disabled
                                v-model="from_set_data.given_name"
                            />
                        </v-row>
                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">ゴルフ場</div>
                            <v-select
                                class="selectBox px-3"
                                disabled
                                :items="golf_courses"
                                item-text="golf_name"
                                item-value="golf_code"
                                v-model="from_set_data.golf_code"
                            ></v-select>
                        </v-row>
                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">権限</div>
                            <v-select
                                class="selectBox px-3"
                                disabled
                                :items="user_divs"
                                item-text="code_name"
                                item-value="code"
                                v-model="from_set_data.user_div"
                            ></v-select>
                        </v-row>
                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">ID</div>
                            <v-text-field
                                class="px-3"
                                disabled
                                v-model="from_set_data.user_name"
                                :rules="[rules.required_user_id]"
                                label="ID" />
                        </v-row>
                        <v-row justify="space-around">
                            <div class="cardWrap__fromArea__title">パスワード</div>
                            <!-- 詳細画面用 -->
                            <v-text-field
                                type="text"
                                class="px-3"
                                id="passInput"
                                maxlength="128"
                                :disabled="inputDisable"
                                v-model="from_set_data.display_password"
                                :rules="[rules.required_password, rules.format_password, rules.format_password_complexity, rules.max_length_password, rules.min_length_password]"
                                />
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="modeStatus === 'checkMode'" color="green darken-4" text @click="InfoChangeData" :disabled="btnActive('001')">変更</v-btn>
                <v-btn v-if="modeStatus === 'changeMode'" color="green darken-4" text @click="validateCheck" :disabled="btnActive('002')">変更</v-btn>
            </v-card-actions>
            <v-overlay :value="changeOverlay">
                <v-card light width="500px">
                    <v-card-title v-if="result === ''">パスワード変更の最終確認</v-card-title>
                    <v-card-title v-if="result !== ''">パスワード変更</v-card-title>
                    <v-card-text v-if="result === ''">{{ full_name }}さんのパスワードを変更します。</v-card-text>
                    <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="result === ''" color="primary" text @click="changeOverlay = !changeOverlay">キャンセル</v-btn>
                        <v-btn v-if="result === ''" color="primary" text @click="changeAdminMember">変更する</v-btn>
                        <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                    </v-card-actions>
                </v-card>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';
import {
    GET_ADMIN,
    UPDATE_ADMIN } from '../../constants/admin';
import {
    GET_FLAG_FROM_CODE_MASTER,
    GET_GOLFCOURSE_FOR_SYSTEM_ADMIN } from '../../constants/master';
import { GET_LOGIN_ADMIN } from '@/constants/login';
import { authorityMixin } from '@/views/authorityMixin';
// パスワード変更
const VUE_ID = 'SCR0012';

export default {
    components: {
        CardTitle
    },
    mixins: [authorityMixin],
    data () {
        return {
            // 変更確認用ポップアップ表示に関する制御値
            changeOverlay: false,
            // 処理結果
            result: '',
            // 処理結果メッセージ
            resultText: '',
            error: '',
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: 'パスワード変更',
            // 画面のモード指定
            // [値：checkData = 管理ユーザー参照],[値：addMember = 会員追加],[値：changeData = 情報変更]
            modeStatus: 'checkMode',
            // 必須項目に関するチェック値
            valid: true,
            // 入力項目の活性・非活性制御値 [true=入力不可][false=入力可]
            inputDisable: false,
            // バリデーションチェック値
            lazy: false,
            // 情報変更を行う際の制御値
            data_change_flag: false,
            // 入力値管理用
            from_set_data: {
                family_name: '',
                given_name: '',
                golf_code: '',
                user_div: '',
                // 管理ユーザーのログインID
                user_name: '',
                // 表示用パスワード
                display_password: ''
            },
            // getAdminで取得したuser_id
            user_id: '',
            // 所属ゴルフグループから取得したゴルフ場
            golf_courses: [],
            // ゴルフ場セレクトボックスの値
            golf_courses_val: '',
            // 権限セレクトボックスの値
            user_divs: [],
            btn: [
                { element_id: '001', isActive: true },
                { element_id: '002', isActive: true }
            ],
            vue_id: VUE_ID,
            rules: {
                // user_id バリデーション
                required_user_id: value => !!value || this.$t('error.validation.required.userId'),
                // パスワードバリデーション
                required_password: value => !!value || this.$t('error.validation.required.password'),
                format_password: value => validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                format_password_complexity: value => validater.checkComplexity(value) || this.$t('error.validation.complexity'),
                max_length_password: value => value.length <= 128 || this.$t('error.validation.length.passwordMax'),
                min_length_password: value => value.length >= 10 || this.$t('error.validation.length.adminPasswordMin')
            }
        };
    },
    computed: {
        full_name: function () {
            return this.from_set_data.family_name + ' ' + this.from_set_data.given_name;
        }
    },
    watch: {
        modeStatus: function () {
            if (this.modeStatus === 'checkMode') {
                this.page_title = 'パスワード変更';
                this.inputDisable = true;
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = 'パスワード変更';
                this.inputDisable = false;
            }
        }
    },
    created () {
        this.getAuthority();
        this.Initialize();
        this.getGolfCourse();
        this.getAdmin();
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.modeStatus = 'checkMode';
            this.user_id = '';
            this.from_set_data.family_name = '';
            this.from_set_data.given_name = '';
            this.from_set_data.golf_code = '';
            this.from_set_data.user_div = '';
            this.from_set_data.user_name = '';
            this.from_set_data.display_password = '';
            this.inputDisable = true;
            this.changeOverlay = false;
            this.result = '';
            this.resultText = '';
            this.golf_groups_val = process.env.VUE_APP_GROUP_CODE;
            // コードマスタより管理者区分のリストを取得
            this.$apollo.query({
                query: GET_FLAG_FROM_CODE_MASTER,
                variables: {
                    code_key: 'authority',
                    default_display: 0
                }
            }).then(res => {
                this.user_divs = res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
         * 管理ユーザーを取得
         * ---------------------------------------------- */
        async getAdmin () {
            // トークンからログインユーザーのIDを取得する
            this.user_id = await this.$apollo.mutate({
                mutation: GET_LOGIN_ADMIN
            }).then(res => {
                return res.data.getLoginAdmin.user_id;
            });
            // IDからログインユーザーの情報を取得する
            await this.$apollo.mutate({
                mutation: GET_ADMIN,
                variables: { user_id: this.user_id }
            }).then(res => {
                this.from_set_data.family_name = res.data.GetAdmin.family_name;
                this.from_set_data.given_name = res.data.GetAdmin.given_name;
                this.from_set_data.golf_code = res.data.GetAdmin.golf_code;
                this.from_set_data.user_div = res.data.GetAdmin.user_div;
                this.from_set_data.user_name = res.data.GetAdmin.user_name;
                this.from_set_data.save_user_name = res.data.GetAdmin.user_name;
                this.from_set_data.display_password = res.data.GetAdmin.display_password;
                this.golf_courses_val = res.data.GetAdmin.golf_code;
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * ゴルフ場を取得
         * ---------------------------------------------- */
        getGolfCourse () {
            this.$apollo.query({
                query: GET_GOLFCOURSE_FOR_SYSTEM_ADMIN,
                variables: { golf_group_code: process.env.VUE_APP_GROUP_CODE }
            }).then(res => {
                this.data = res.data.getGolfCourseForSystemAdmin;
                this.golf_courses_val = this.data[0].golf_code;
                this.data.forEach(data => {
                    this.golf_courses.push(data);
                });
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 管理ユーザー変更
         * ---------------------------------------------- */
        changeAdminMember () {
            let insertGolfCode = this.golf_courses_val;
            // システム管理者の場合
            if (this.from_set_data.user_div === '1') {
                insertGolfCode = process.env.VUE_APP_ADMIN_GOLF_CODE;
            }
            this.$apollo.mutate({
                mutation: UPDATE_ADMIN,
                variables: {
                    user_id: this.user_id,
                    user_name: this.from_set_data.user_name,
                    save_user_name: this.from_set_data.save_user_name,
                    family_name: this.from_set_data.family_name,
                    given_name: this.from_set_data.given_name,
                    password: this.from_set_data.display_password,
                    golf_group_code: this.golf_groups_val,
                    golf_code: insertGolfCode,
                    user_div: this.from_set_data.user_div
                }
            }).then(res => {
                this.result = res.data.UpdateAdmin.result;
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.change');
                } else {
                    this.resultText = this.$t('result.error.change');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.change');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        },
        /** ----------------------------------------------
         * 詳細表示画面表示に情報変更ボタンを押下した際の処理
         * ---------------------------------------------- */
        InfoChangeData () {
            this.modeStatus = 'changeMode';
            document.getElementById('passInput').focus();
            this.data_change_flag = true;
        },
        CloseModal () {
            this.Initialize();
            this.getAdmin();
        }
    }
};
</script>

<style scoped>

.selectBox ::v-deep i{
    display: none;
}

</style>
